import intersection from "lodash/intersection";
import { GRAPH_API_URL, ALLOWED_USER_GROUPS } from "../config";
import { getHeaders } from "../utils/request";

export enum UserGroup {
  WAREHOUSE_PERSONNEL_GROUP = "WAREHOUSE_PERSONNEL_GROUP",
}

export const findUserGroups = async (): Promise<UserGroup[]> => {
  try {
    const headers = await getHeaders();
    const res = await fetch(GRAPH_API_URL + "/me/checkMemberGroups", {
      method: "POST",
      headers,
      body: JSON.stringify({
        groupIds: ALLOWED_USER_GROUPS,
      }),
    });

    const { value: userGroups } = await res.json();

    const groups = [];
    if (intersection(userGroups, ALLOWED_USER_GROUPS).length > 0) {
      groups.push(UserGroup.WAREHOUSE_PERSONNEL_GROUP);
    }
    return groups;
  } catch (error) {
    console.error(error);
    throw new Error("Käyttäjätietojen haku epäonnistui. Yritä myöhemmin uudelleen.");
  }
};
